import React from 'react';
import { useUser } from '../../context/UserContext';
import { useParams } from 'react-router-dom';

// Import components for different user roles
import IssuerDetails from '../IssuerDetails/IssuerDetails'; // For admin/internal users
import LandingIssuerDetails from '../LandingPages/IssuerDetails'; // For external users

const ConditionalIssuerDetailsRoute = () => {
  const { userData } = useUser();
  const { issuerId } = useParams();
  const searchParams = new URLSearchParams(window.location.search);
  const issuerIdFromQuery = searchParams.get('issuerId');
  
  // Use issuerId from URL params or query string
  const finalIssuerId = issuerId || issuerIdFromQuery;

  // Check if user is external (only EXTERNAL_USER role)
  const isExternalUser = () => {
    if (!userData || !userData.roles || userData.roles.length === 0) {
      return true; // Default to external if no roles
    }
    
    // Check if user has EXTERNAL_USER role
    return userData.roles.includes('EXTERNAL_USER');
  };

  // Render appropriate component based on user role
  if (isExternalUser()) {
    console.log('Rendering external IssuerDetails component for user:', userData?.username);
    return <LandingIssuerDetails skipLayout={true} />;
  } else {
    console.log('Rendering internal IssuerDetails component for user:', userData?.username);
    return <IssuerDetails />;
  }
};

export default ConditionalIssuerDetailsRoute;
